import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TextField as BaseTextField, alpha, useTheme } from "@mui/material";
/**
 * @deprecated Please use TextField or Select from `/lab`
 */
export const TextField = ({ success, warning, error, holdHelperTextHeight, transparent, readonly, helperText, required, variant = "outlined", SelectProps, InputProps, sx, id, testable, ...props }) => {
    const theme = useTheme();
    const stateColor = error
        ? theme.palette.error.main
        : warning
            ? theme.palette.warning.main
            : success
                ? theme.palette.success.main
                : undefined;
    return (_jsx(BaseTextField, { "data-component-name": "TextField", id: id, variant: variant, helperText: holdHelperTextHeight && !helperText && !required
            ? " "
            : required && !helperText
                ? "Required*"
                : `${helperText ? helperText : ""}${required ? "*" : ""}`, InputProps: {
            readOnly: readonly,
            ...InputProps,
        }, SelectProps: {
            ...SelectProps,
            MenuProps: {
                ...SelectProps?.MenuProps,
                sx: {
                    zIndex: (theme) => theme.zIndex.menu,
                    ...SelectProps?.MenuProps?.sx,
                },
            },
        }, error: error, ...props, sx: {
            backgroundColor: (theme) => transparent ? "transparent" : theme.palette.background.main,
            "& .MuiInputBase-root": {
                ...theme.typography.body2,
                borderRadius: 0.5,
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: (theme) => stateColor || theme.palette.outline,
                "& legend": {
                    fontSize: "0.85em",
                },
            },
            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: (theme) => `${stateColor || theme.palette.outline} !important`,
            },
            "& .MuiInputLabel-root": {
                color: (theme) => stateColor || theme.palette.background.onMain,
                "&.Mui-disabled": {
                    color: (theme) => alpha(theme.palette.background.onMain, theme.alpha.disabled),
                },
                "&.Mui-focused": {
                    color: (theme) => theme.palette.background.onMain,
                },
            },
            "& .MuiFormHelperText-root": {
                typography: (theme) => theme.typography.body4,
                color: (theme) => stateColor || theme.palette.background.onMain,
                margin: 0,
                paddingTop: 0.5,
                paddingX: 1.75,
            },
            "& .MuiInputBase-adornedEnd": {
                color: (theme) => stateColor || theme.palette.background.onMain,
            },
            "& .MuiInputBase-adornedStart": {
                color: (theme) => stateColor || theme.palette.background.onMain,
            },
            "& .MuiInputBase-inputAdornedStart": {
                paddingLeft: 2,
            },
            "& .MuiInputBase-inputAdornedEnd": {
                paddingRight: 2,
            },
            //Used to ensure full background coverage when google autocomplete is used
            "input:-webkit-autofill": {
                "-webkit-box-shadow": `0 0 0px 1000px ${theme.palette.surface.container} inset !important`,
            },
            "textarea:-webkit-autofill": {
                "-webkit-box-shadow": `0 0 0px 1000px ${theme.palette.surface.container} inset !important`,
            },
            "select:-webkit-autofill": {
                "-webkit-box-shadow": `0 0 0px 1000px ${theme.palette.surface.container} inset !important`,
            },
            ...sx,
        } }));
};
//# sourceMappingURL=TextField.js.map